import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sendMeATestEmailButtonLabel: {
		id: 'language-settings.send-me-a-test-email.send-me-a-test-email-button-label',
		defaultMessage: 'Send me a test email',
		description: 'Label for the button to send a test email',
	},
	htmlEmailLabel: {
		id: 'language-settings.send-me-a-test-email.html-email-label',
		defaultMessage: 'HTML email',
		description: 'Label for the html email body',
	},
	plainTextEmailLabel: {
		id: 'language-settings.send-me-a-test-email.plain-text-email-label',
		defaultMessage: 'Plain text email',
		description: 'Label for the Plain text email body',
	},
});
